import './styles.scss';
const BetaBar = (props) => {
    if (props.route && (props.route.type === 'foodservice' || props.route.type === 'livs')) {

        //Find the subdomain of the current domain and replace it with the beta version
        const domainParts = window.location.hostname.split('.');
        const url = `https://${domainParts[0]}-beta.${domainParts[1]}.${domainParts[2]}/scenario`;

        return (
            <div className="beta-bar">
                <div className="beta-bar__content">
                    <p>
                        <strong>Nyhet!</strong> Nu blir det enklare att arbeta med säljdistrikt! Pröva den nya versionen av säljdistriktet <a href={url}>här</a>.
                    </p>
                </div>
            </div>
        );
    }

    return null;
};

export default BetaBar;